import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static values = { requestId: String, analysisReady: Boolean }
  static targets = ['message']

  connect() {
    this.subscription = consumer.subscriptions.create({ channel: `PublicGeogridAnalysisChannel`, requestId: this.requestIdValue }, {
      connected: this._connected.bind(this),
      disconnected: this._disconnected.bind(this),
      received: this._received.bind(this)
    })

  }

  disconnect() {
    this.subscription.unsubscribe()
  }

  _connected() {
  }

  _disconnected() {
  }

  _received(data) {
    let elem = document.getElementById("waiting_message");
    elem.classList.replace('opacity-100', 'opacity-0');

    setTimeout(() => {
      elem.classList.add('hidden');

      this.messageTarget.innerHTML = data;
      this.messageTarget.classList.remove('hidden');
      this.messageTarget.classList.replace('opacity-0', 'opacity-100');
    }, 500);
  }

}
